<div class="mas-container">
    <p class="title">Listado de Aprobaciones</p>
    <button fxFlexAlign="flex-end" mat-mini-fab class="green" matTooltip="Crear Cuenta" matTooltipPosition="left"
        matTooltipClass="tooltip" (click)="create(null)">
        <mat-icon>add</mat-icon>
    </button>
    <div *ngIf="loading" class="mas-container-loader">
        <div class="mas-loader"></div>
    </div>
    <table *ngIf="!loading" class="mas-table" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="mail">
            <th mat-header-cell *matHeaderCellDef>Correo</th>
            <td mat-cell *matCellDef="let item">{{item.mail}}</td>
        </ng-container>
        <ng-container matColumnDef="approvalUser">
            <th mat-header-cell *matHeaderCellDef>Usuario de Aprobacion</th>
            <td mat-cell *matCellDef="let item">{{item.approvalUser}}</td>
        </ng-container>
        <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef>Activo</th>
            <td mat-cell *matCellDef="let item">
                <mat-icon *ngIf="item.active" class="green-color">done</mat-icon>
                <mat-icon *ngIf="!item.active" class="red-color">clear</mat-icon>
            </td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let item">
                <button mat-icon-button matTooltip="Editar" matTooltipPosition="above" matTooltipClass="tooltip"
                    (click)="create(item)">
                    <mat-icon class="blue-color">create</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Eliminar" matTooltipPosition="above" matTooltipClass="tooltip"
                    (click)="delete(item.id)">
                    <mat-icon class="red-color">delete</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
    <mat-paginator #paginator [pageSizeOptions]="[5, 10, 15, 20, 30, 40, 50, 100]" showFirstLastButtons>
    </mat-paginator>
</div>